export const popupFooterSaveButtonStyles = {
  background: '#2F736E',
  borderRadius: '12px',
  fontFamily: 'Manrope, sans-serif',
  fontWeight: 700,
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  padding: '10px 24px',
  color: '#F6F8F9',
  '&:hover': {
    background: '#2F736E',
  },
  textTransform: 'none',
};

export const popupFooterCancelButtonStyles = {
  fontFamily: 'Manrope, sans-serif',
  background: 'transparent',
  fontWeight: 700,
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  border: 'none',
  borderRadius: '12px',
  color: '#51B8B0',
  '&:hover': {
    border: 'none',
    background: 'none',
  },
  textTransform: 'none',
};
